import { useEffect, useRef, useState } from 'react';
import Router from 'next/router';

export function useRouteLoading(minVisibleMs = 250) {
	const [loading, setLoading] = useState(false);
	const activeCount = useRef(0);
	const visibleSince = useRef<number | null>(null);
	const hideTimer = useRef<number | null>(null);

	const show = () => {
		if (!loading) {
			setLoading(true);
			visibleSince.current = Date.now();
		}
	};

	const hide = () => {
		const shownAt = visibleSince.current ?? Date.now();
		const elapsed = Date.now() - shownAt;
		const remaining = Math.max(0, minVisibleMs - elapsed);
		if (hideTimer.current) window.clearTimeout(hideTimer.current);
		hideTimer.current = window.setTimeout(() => {
			setLoading(false);
			visibleSince.current = null;
			hideTimer.current = null;
		}, remaining);
	};

	useEffect(() => {
		const onStart = (url: string) => {
			activeCount.current += 1;
			show();
		};
		const onEnd = () => {
			activeCount.current = Math.max(0, activeCount.current - 1);
			if (activeCount.current === 0) hide();
		};

		Router.events.on('routeChangeStart', onStart);
		Router.events.on('routeChangeComplete', onEnd);
		Router.events.on('routeChangeError', onEnd);
		return () => {
			Router.events.off('routeChangeStart', onStart);
			Router.events.off('routeChangeComplete', onEnd);
			Router.events.off('routeChangeError', onEnd);
			if (hideTimer.current) window.clearTimeout(hideTimer.current);
		};
	}, [minVisibleMs]);

	return loading;
}
